import { Context } from "@nuxt/types";

import Api from "@/utils/api";
import debounce from "@/utils/debounce";

const DEFAULT_LTK_LIMIT = 36;

export default class LtksApi extends Api {
  readonly url = "/v2/ltks";

  constructor($axios: Context["$axios"]) {
    super("postService", $axios);
  }

  async get({
    displayName,
    profileId,
    ids,
    hashes,
    featured,
    hashtag,
    limit = DEFAULT_LTK_LIMIT,
    lastId,
    seed,
  }: LtkParams) {
    return await this.request<ManyLtksResponse>({
      method: "GET",
      params: {
        display_name: displayName,
        profile_id: profileId,
        ids,
        hashes,
        featured,
        hashtag,
        limit,
        last_id: lastId,
        seed,
        link_types: ["LTK_WEB"],
      },
    });
  }

  async getPopularTodayFeed({ limit = DEFAULT_LTK_LIMIT, lastId }: LtkParams) {
    return await this.request<ManyLtksResponse>({
      method: "GET",
      params: {
        rank: "24h",
        trending: true,
        limit,
        styled: true,
        includes: ["products", "profiles"],
        last_id: lastId,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: DEFAULT_LTK_LIMIT })
  async getOneAggregate(...ids: string[]) {
    return await this.get({ ids });
  }

  async getOne(id: string) {
    return await this.get({ ids: [id] });
  }

  async getOneHash(...hashes: string[]) {
    return await this.get({ hashes });
  }
}
